// Find Perfect Section - Video Hover Functionality
(function () {
    function initFindPerfectSection(section) {
        const boxes = section.querySelectorAll('.box');
        if (boxes.length === 0) return;

        const videos = section.querySelectorAll('.box_video');

        // Check if device is mobile/tablet (breakpoint: 1024px)
        const isMobile = () => window.innerWidth < 1024;

        // Initialize videos based on device type
        function initVideos() {
            videos.forEach((video) => {
                if (!video) return;

                if (isMobile()) {
                    // Mobile: Auto-play all videos on loop
                    video.muted = true;
                    video.loop = true;
                    video.play().catch((err) => {
                        console.log('Mobile video autoplay prevented:', err);
                    });
                } else {
                    // Desktop: Pause by default, will play on hover
                    video.pause();
                    video.currentTime = 0;
                }
            });
        }

        // On many mobile browsers, autoplay still needs a user gesture.
        // Attach a one-time listener that force-plays all videos after first tap/click.
        function enableMobileAutoplayOnInteraction() {
            if (!isMobile() || videos.length === 0) return;

            const tryPlayAll = () => {
                videos.forEach((video) => {
                    if (!video) return;
                    video.muted = true;
                    video.loop = true;
                    video.play().catch((err) => {
                        console.log('Mobile video autoplay after interaction prevented:', err);
                    });
                });
            };

            const onceHandler = () => {
                tryPlayAll();
                window.removeEventListener('touchstart', onceHandler);
                window.removeEventListener('click', onceHandler);
            };

            window.addEventListener('touchstart', onceHandler, { once: true });
            window.addEventListener('click', onceHandler, { once: true });
        }

        // Desktop hover functionality
        function setupDesktopHover() {
            if (isMobile()) return;

            boxes.forEach((box) => {
                const video = box.querySelector('.box_video');
                if (!video) return;

                let hoverTimeout;

                box.addEventListener('mouseenter', () => {
                    clearTimeout(hoverTimeout);
                    hoverTimeout = setTimeout(() => {
                        video.currentTime = 0;
                        video.play().catch((err) => {
                            console.log('Video play error on hover:', err);
                        });
                    }, 100); // Small delay to ensure smooth transition
                });

                box.addEventListener('mouseleave', () => {
                    clearTimeout(hoverTimeout);
                    video.pause();
                    video.currentTime = 0;
                });
            });
        }

        // Handle window resize
        let resizeTimeout;
        const handleResize = () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
                initVideos();
                setupDesktopHover();
            }, 250);
        };

        window.addEventListener('resize', handleResize);

        // Initialize on load
        initVideos();
        setupDesktopHover();
        enableMobileAutoplayOnInteraction();

        // Ensure videos loop properly
        boxes.forEach((box) => {
            const video = box.querySelector('.box_video');
            if (!video) return;

            video.addEventListener('ended', () => {
                if (isMobile() || box.matches(':hover')) {
                    video.currentTime = 0;
                    video.play().catch((err) => {
                        console.log('Video replay error:', err);
                    });
                }
            });
        });
    }

    // Initialize all sections on the page
    function initAllSections() {
        const sections = document.querySelectorAll('.kroslo-find-perfect');
        sections.forEach((section) => {
            initFindPerfectSection(section);
        });
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAllSections);
    } else {
        initAllSections();
    }

    // Re-initialize when Shopify theme editor loads new sections
    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
        document.addEventListener('shopify:section:load', function(event) {
            const section = event.detail.target.querySelector('.kroslo-find-perfect');
            if (section) {
                initFindPerfectSection(section);
            }
        });
    }
})();
